export const SET_CONTACT_PROVIDER_API_STATUS = 'SET_CONTACT_PROVIDER_API_STATUS';
export function setContactProviderAuthenticationApiStatus(contactProviderPayload) {
  return { type: SET_CONTACT_PROVIDER_API_STATUS, payload: contactProviderPayload };
}
